import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/stop-vaping/impact_banner.webp";

function Impactvaping() {
  return (
    <section
      className="impact_vaping text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Impact</h2>
            <p>
              Launching into its niche market, this revolutionary app is
              responsible for reducing the number of vaping adults, while also
              the number of consequential casualties in our society.
            </p>
            <p>Share the app with someone who might need it:</p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/ca/app/stop-vaping-challenge/id1574343369">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.app.stopvaping">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
            <div className="impact_mob_img d-block d-md-none">
              <StaticImage
                src="../../../images/case-studies/stop-vaping/impact_mob.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={778}
                height={656}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Impactvaping;
